import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region META

function _Meta(props) {
    const hasValue = !Utilities.isHTMLContentEmpty(props.content);
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const Meta = withLabelTokenParsing(_Meta, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Date:
            if (!Utilities.isNullOrWhitespace(data.TermDate)) {
                replaceString = Token.getReplacementString(data.TermDate, options);
            }
            break;
        case Token.Terms:
            if (!Utilities.isNullOrWhitespace(data.Terms)) {
                replaceString = Token.cleanTokenValueForReplacement(data.Terms, options);
            }
            break;
        case Token.Title:
            if (!Utilities.isNullOrWhitespace(data.Title)) {
                replaceString = Token.getReplacementString(data.Title, options);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});

const Tokens = () => {
    return [
        Token.getWrappedTokenConfig('Title', Token.Title),
        Token.getWrappedTokenConfig('Term Date', Token.Date),
        Token.getWrappedTokenConfig('Terms', Token.Terms)
    ]
};
const TypeConfig = {
    defaultDesign: () => `${Utilities.wrapTextForEditor({ text: `{${Token.Title}("before":"","after":"")}`, token: Token.Title })}${Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":"","after":"")}`, token: Token.Date })}`,
    panel: {
        block: () => LabelValueTypeConfig.panel.block(1),
        description: LabelValueTypeConfig.panel.description,
        label: LabelValueTypeConfig.panel.label,
        style: LabelValueTypeConfig.panel.style,
        value: (defaultDesign) => LabelValueTypeConfig.panel.value(defaultDesign || TypeConfig.defaultDesign())
    }
};

// #endregion META

export {
    Meta as Component,
    Tokens,
    TypeConfig
};